// Application status constants
export const APPLICATION_STATUS = {
	DRAFT: "draft",
	PENDING: "pending",
	COMMITTEE_APPROVAL_PENDING: "committee_approval_pending",
	CHALLAN_UNPAID: "challan_unpaid",
	CHALLAN_PAID: "challan_paid",
	UNPAID: "unpaid",
	SCRUTINIZED: "scrutinized",
	APPROVED: "approved",
	CERTIFIED: "certified",
	REFERRED_BACK: "referred_back",
	REJECTED: "rejected",
	/** Superseded renew draft (replaced when a newer renew starts) — not an active in-progress application. */
	INCOMPLETE: "incomplete",
	NO_APPLICATION: "NO_APPLICATION",
} as const;

// Application type constants
export const APPLICATION_TYPE = {
	NEW: "new",
	RENEW: "renew",
} as const;

// Application status keys
export const APPLICATION_STATUS_KEY = {
	NEW_REGISTRATION: "new_registration",
	RENEWAL_WITH_CHANGE: "renewal_with_change",
	COURSE_APPLICATION: "course_application",
	TRACK_APPLICATION: "track_application",
	CHALLAN_UNPAID: "challan_unpaid",
	CHALLAN_PAID: "challan_paid",
	APPROVED: "approved",
	CERTIFIED: "certified",
} as const;

// Button action constants
export const BUTTON_ACTION = {
	REGISTER: "register",
	COURSE_DETAILS: "course_details",
	TRACK: "track",
	RENEWAL_COURSES: "renewal_courses",
	RENEWAL_INSTITUTE: "renewal_institute",
	PAY_CHALLAN: "pay_challan",
	SUBMIT: "submit",
} as const;

// Status text constants
export const STATUS_TEXT = {
	DRAFT: "Draft",
	CHALLAN_UNPAID: "Challan Unpaid",
	CHALLAN_PAID: "Challan Paid",
	CHALLAN_PAID_SUBMITTED: "Challan paid & Submitted",
	SCRUTINIZED: "Scrutinized",
	APPROVED: "Approved",
	CERTIFIED: "Certified",
	REFERRED_BACK: "Referred Back",
	REJECTED: "Rejected",
	UNKNOWN: "Unknown",
	NO_APPLICATION: "No Application",
} as const;

// Button text constants
export const BUTTON_TEXT = {
	UPDATE_DETAILS: "Update Details",
	REGISTER_NOW: "Register Now",
	COMPLETE_REGISTRATION: "Complete registration",
	COMPLETE_RENEWAL: "Complete Renewal",
	COURSE_APPLICATION: "Course Application",
	RENEWAL_COURSES: "Add Courses",
	TRACK_APPLICATION: "Track Application",
} as const;

// Facility type constants
export const FACILITY_TYPE = {
	INDOOR: "Indoor",
	OUTDOOR: "Outdoor",
} as const;

// Renewal type constants
export const RENEWAL_TYPE = {
	ENHANCEMENT_OF_SEATING: "enhancement_of_seating",
	ADDITION_OF_TRADE: "addition_of_trade",
	ADDITION_OF_NON_REGULAR_TRADE: "addition_of_non_regular_trade",
	CHANGE_OF_OWNERSHIP: "change_of_ownership",
	CHANGE_OF_NAME: "change_of_name",
	CHANGE_OF_ADDRESS: "change_of_address",
	WITHOUT_CHANGE: "without_change",
	WITH_CHANGE: "with_change",
} as const;

// Facility field constants
export const FACILITY_FIELD = {
	FACILITIES_SUFFIX: "_facilities",
} as const;

// Course status constants
export const COURSE_STATUS = {
	ACTIVE: "active",
	COMPLETED: "completed",
} as const;

// Step constants for Register Institute
export const REGISTER_INSTITUTE_STEPS = {
	MAIN_STEP: {
		INSTITUTE_DETAILS: 0,
		BUILDING_DETAILS: 1,
		ATTACHMENTS: 2,
	},
	SUB_STEP: {
		BASIC_INFO: 0,
		ADDRESS_DETAILS: 1,
		OWNERSHIP_DETAILS: 2,
		INDOOR_FACILITIES: 1,
		OUTDOOR_FACILITIES: 2,
		OTHER_FACILITIES: 3,
	},
} as const;

// Case constants for Register Institute form handling
export const REGISTER_INSTITUTE_CASES = {
	MAIN_STEP: {
		INSTITUTE_DETAILS: 0,
		BUILDING_DETAILS: 1,
		ATTACHMENTS: 2,
	},
	SUB_STEP: {
		BASIC_INFO: 0,
		ADDRESS_DETAILS: 1,
		OWNERSHIP_DETAILS: 2,
		INDOOR_FACILITIES: 1,
		OUTDOOR_FACILITIES: 2,
		OTHER_FACILITIES: 3,
	},
} as const;
